import { render, staticRenderFns } from "./AtomIconAndText.vue?vue&type=template&id=743ffcaa&"
import script from "./AtomIconAndText.vue?vue&type=script&lang=js&"
export * from "./AtomIconAndText.vue?vue&type=script&lang=js&"
import style0 from "./AtomIconAndText.vue?vue&type=style&index=0&id=743ffcaa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default})
